import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from '@material-ui/core';
import {mergeWithDefault} from '../Form/utils';
import swal from 'sweetalert';
import {object, string, boolean} from 'yup';
import FormFields from './FormFields';
import GlobalContext from '../../globalContext';
import Query from 'react-apollo/Query';
import {SubContacts} from './FormFields/SubContacts';
import GraphQlLoading from '../GraphQl/Loading';
import GraphQlError from '../GraphQl/Error';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import ContactTable from "./ContactTable";
import FormField from "../Form/FormField";
import InputAdornment from "@material-ui/core/InputAdornment";


class ContactForm extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {contacts: ''};
    }

    setContacts  = (contacts) =>  {
        this.setState({contacts: contacts})
    };

    render() {
        const {
            values,
            contactType,
            isCreateSelf,
            isEmployee,
            newAddressNumbers,
            classes,
        } = this.props;

        //@todo
        // work time needs a user?_id from contacts for the ability to enter work time
        // another solution required
        //values.user_id = isCreateSelf ? this.context.user.id : null; // null not possible
        values.email = isEmployee ? this.context.user.email : values.email;

        return <React.Fragment>
            <FormFields {...this.props} contactType={contactType}>

                { values.is_company && (
                    <React.Fragment>
                        <Divider className={classes.divider}/>
                        <Grid container>
                            <Grid item xs={12} sm={3}>
                                <Typography variant="h6" className={classes.vSpace}>
                                    {i18n.get('contacts.contact_persons')}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={9}>
                                <FormField
                                    helperText={i18n.get('contacts.key_contact.self')}
                                    InputProps={{
                                        readOnly: true,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Icon fontSize="small" className={this.state.contacts ? classes.iconActive : classes.icon}>account_circle</Icon>
                                            </InputAdornment>
                                        ),
                                    }}
                                    value={this.state.contacts}
                                />

                            </Grid>
                        </Grid>
                        {values.id > 0 ? (
                        <Query
                            query={SubContacts.query}
                            variables={{parent_id: values.id}}
                        >
                            {({loading, error, data}) => {

                                if (loading) {
                                    return <GraphQlLoading/>;
                                }
                                if (error) {
                                    return <GraphQlError/>;
                                }

                                return data.contacts.data && data.contacts.data.length > 0
                                    ? <ContactTable
                                        contacts={data.contacts.data}
                                        setContacts={this.setContacts}
                                        parent={values}
                                        edit={this.props.isEdit}
                                    />
                                    : <div>{i18n.get('default.empty')}</div>
                            }}
                        </Query>
                        ) : <div>{i18n.get('default.empty')}</div>}
                    </React.Fragment>
                )}
                <Divider className={classes.divider}/>
            </FormFields>
        </React.Fragment>;
    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => mergeWithDefault(props.values, {
        contact_type: props.contactType || '',
        tenant_since: '',
        address_number: '',
        first_name: '',
        last_name: '',
        is_company: props.contactType === 'craft', // needs to be correct type, otherwise validationSchema-value undefined
        type_of_relation: '',
        key_contacts: '',
        company_name: '',
        department: '',
        street: '',
        number: '',
        description: '',
        zip: '',
        city: '',
        landline: '',
        email: '',
        mobile: '',
        salutation: '',
        user_id: window.__DATA__._user.id,
        parent_id: props.parentId,
        key_contact_id: props.keyContactId || null,
        files: [],
        new_contact:false,
    }),

    validationSchema: () => {
        let rules = {
            is_company: boolean().required(),
            company_name: string().when('is_company', (is_company, schema) => {
                return is_company === true ? schema.required(
                    i18n.get('validation.required', {attribute: i18n.get('contacts.company_name')}),
                ) : schema;
            }),
            type_of_relation: string().when('is_company', (is_company, schema) => {
                return is_company === true ? schema.required(
                    i18n.get('validation.required', {attribute: i18n.get('contacts.relation.self')}),
                ) : schema;
            }),
            first_name: string().when('is_company', (is_company, schema) => {
                return is_company !== true ? schema.required(
                    i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')}),
                ) : schema;
            }),
            last_name: string().when('is_company', (is_company, schema) => {
                return is_company !== true ? schema.required(
                    i18n.get('validation.required', {attribute: i18n.get('contacts.last_name')}),
                ) : schema;
            }),
            street: string().label(i18n.get('contacts.street')).required(),
            number: string().label(i18n.get('contacts.number')).required(),
            zip: string().label(i18n.get('contacts.zip')).required(),
            city: string().label(i18n.get('contacts.city')).required(),
            email: string().label(i18n.get('contacts.email')).required(),
        };

        return object().shape(rules);
    },

    handleSubmit: (values, {props}) => {

        axios.post(props.formUrl, values).then((response) => {
            if(values.new_contact) {
                let parent = response.data.contact;
                if(parent && parent.id) {
                    window.location.href = `/contacts/person/create?parent_id=${parent.id}`;
                } else {
                    swal({
                        icon: 'warning',
                        text: i18n.get('contacts.error.please_save_company'),
                    }).then();
                }
            } else {
                swal({
                    icon: 'success',
                    title: i18n.get('contacts.save_success'),
                    text: i18n.get('contacts.you_will_be_redirected'),
                    timer: 4000,
                }).then(() => {

                    if(values.parent_id) {
                        window.location.href = `/contacts/craft/${values.parent_id}/edit`;
                    } else {
                        window.location.href = `/contacts/search/crafts`;
                    }
                });
            }
        }).catch(() => {
            swal({
                icon: 'error',
                title: i18n.get('contacts.ajax_error'),
            }).then();
        });
    },

    validateOnBlur: true,

})(ContactForm);

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    vSpace: {
        marginTop: theme.spacing.unit * 2,
    },
    divider: {
        marginTop: theme.spacing.unit * 2,
    },
    addButton: {
        marginTop: 16,
    },
    formField: {
        width: '50%'
    },
    icon: {
        opacity: 0.5,
    },
    iconActive: {
        color: theme.colors.primary,
        opacity: 1,
    },
});

export default withStyles(styles)(FormConfig);
